import eventsService from '../api/events.js'

// initial state
const state = {
  scrolled1000StorageKey: 'scrolled1000StorageKey',
  scrolled2000StorageKey: 'scrolled2000StorageKey',
  scrolled3000StorageKey: 'scrolled3000StorageKey',
}

// getters
const getters = {
  scrolled1000StorageKey: state => { return state.scrolled1000StorageKey },
  scrolled2000StorageKey: state => { return state.scrolled2000StorageKey },
  scrolled3000StorageKey: state => { return state.scrolled3000StorageKey },
}

// mutations
const mutations = {
  // ['EMAIL_SET'] (state, email) {
  //   state.email = email
  // },
}

// actions
const actions = {
  ['EVENT_SEND'] ({commit}, payload) {
    eventsService.sendEvent(payload)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
